import styled from 'styled-components';

import { useTheme } from '../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../Styles/theme';

import MemberStatusListTable from '../../Model/Individual/StatisticsModel/MemberStatusListTable';

import IntroMarkdown from './IntroMarkdown';

export default function MemberStatusRenderer(props) {
  const { data } = props;

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;
  const { intro, memberType, members, accentColor } = data;

  // MemberStatusBox 기준: 등록(신규/재등록) = primary 오렌지, 이탈 = 그린(subKey) // 토큰 사용 — 다크모드 자동 정합
  const defaultAccentColor = memberType === 'churned' ? theme.subKey : theme.primary;

  // 회원 클릭시 상세 페이지 이동 //
  function onClickMember(memberId) {
    window.open('/member/valid/detail/' + memberId, '_blank');
  }

  return (
    <TopLevelWrapper>
      <IntroMarkdown text={intro} color={theme.text} />
      <TableContainer $color={theme.subBackground}>
        <MemberStatusListTable
          members={members}
          memberType={memberType}
          accentColor={accentColor || defaultAccentColor}
          onClickMember={onClickMember} />
      </TableContainer>
    </TopLevelWrapper>
  );
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;

  gap: 12px;
`;

const TableContainer = styled.div`
  display: flex;
  flex-direction: column;

  width: 600px;

  overflow-x: auto;

  border-radius: 10px;
  background-color: ${props => props.theme.subBackground};
`;
